import React, { Component } from 'react'
import {connect} from 'react-redux'

import { saveInstructors } from '../../actions/Instructors'

import Modal from '../Modal'

import { grantAdmin } from '../Utils/Service'

const grant_values = [
  {value: 1, label: 'Ospite'},
  {value: 3, label: 'Utente'},
  {value: 5, label: 'Amministratore'}
]

class EditInstructor extends Component {
  saveInstructors () {
    this.props.saveInstructors(this.state)
  }
  componentWillMount () {
    const i = this.props.instructor
    this.setState({
      id: i.id,
      name: i.name,
      password: '',
      email: i.email,
      grant: i.grant
    })
  }
  render () {
    const { ajaxStatus } = this.props.instructors
    const i = this.state
    return (
      <Modal>
        <h3>{(i.id !== null) ? 'Modifica' : 'Aggiungi'} istruttore</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        <label>
          Nome
          <input
            type="text"
            placeholder="Nome"
            onChange={event => this.setState({ name: event.target.value })}
            value={i.name}
          />
        </label>
        <label>
          Email
          <input
            type="email"
            placeholder="Email"
            onChange={event => this.setState({ email: event.target.value })}
            value={i.email}
          />
        </label>
        <label>
            Password {
            i.id !== null && (
              <b>(lasciare vuota se non la si vuole cambiare)</b>
            )
          }
          <input
            type="text"
            placeholder="Password"
            onChange={event => this.setState({ password: event.target.value })}
            value={i.password}
          />
        </label>
        {
          grantAdmin() && (
            <label>
              Permessi
              <select
                onChange={event => this.setState({ grant: event.target.value })}
                value={i.grant}
              >
                {
                  grant_values.map((i, index) => {
                    return (
                      <option key={index} value={i.value}>{i.label}</option>
                    )
                  })
                }
              </select>
            </label>
          )
        }
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.saveInstructors()}
            >
              salva
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { saveInstructors })(EditInstructor)



// WEBPACK FOOTER //
// ./src/components/Instructors/EditInstructor.js